import { RequestInstance } from "../../../utils/request";

export const roleList = new RequestInstance({
  method: "get",
  url: "/v2/auth/role/page",
});

export const dataList = new RequestInstance({
  method: "get",
  url: "/v2/member/role/list",
});

export const addRole = new RequestInstance({
  method: "post",
  url: "/v2/auth/role/add",
});

export const updateRole = new RequestInstance({
  method: "post",
  url: "/v2/auth/role/update",
});

export const removeRole = new RequestInstance({
  method: "post",
  url: "/v2/auth/role/delete",
});

export const removeOutRole = new RequestInstance({
  method: "post",
  url: "/v2/member/role/remove",
});

export const notBindRoleList = new RequestInstance({
  method: "get",
  url: "/v2/member/role/unbinding/list",
});

export const addBindUsers = new RequestInstance({
  method: "post",
  url: "/v2/member/role/add",
});

export const authModuleCustomList = new RequestInstance({
  method: "get",
  url: "/v2/auth/module/custom/list",
});

export const authAssignUpdate = new RequestInstance({
  method: "post",
  url: "/v2/auth/assign/custom/update",
});
